import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import AppBarPortal from '../components/AppBarPortal';
import AppLeftPortal from '../components/AppLeftPortal';
import AppFooterPortal from '../components/AppFooterPortal';

const styles = {
  pl: {
    paddingLeft: 25
  }
}

class Terms extends React.PureComponent {

  state = {
    title: 'Aviso Legal'
  }

  componentDidMount() {
    document.body.classList.add("login");
    document.title = this.state.title + ' - CosmoCare';
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render() {
    const { classes } = this.props;

    return (
      <main style={{ display: 'block', padding: 25 }}>
        {!isMobile && <AppBarPortal />}
        {!isMobile && <AppLeftPortal />}
        {!isMobile && <AppFooterPortal />}
        
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='headline' align='center' paragraph>Aviso Legal</Typography>
            <Typography paragraph>
              El acceso, navegación y utilización del sitio web https://www.cosmocare.eu (en adelante, 
              el “Sitio Web”) implica la aceptación del usuario, expresa y sin reservas, de 
              todos los términos aquí contenidos. En lo sucesivo, se hará referencia a este documento 
              como “Aviso Legal” o “Condiciones de Uso”, de manera indistinta.
            </Typography>
            <Typography paragraph>
              Su observancia y cumplimiento será exigible a aquel usuario que acceda, 
              navegue o utilice el Sitio Web. Si no está de acuerdo con los términos 
              expuestos, abandone inmediatamente el Sitio Web.
            </Typography>
            <Typography paragraph variant="subheading">
              1. IDENTIFICACIÓN
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Titular: COSMOCARE EXPERT, SOCIEDAD LIMITADA, (en adelante, “COSMOCARE”).<br />
              - Domicilio social: Calle Diputación, núm. 180, Oficinas B-C, 08011 Barcelona.<br />
              - NIF: B-67255455.<br />
              - E-mail: help@cosmocare.eu.
            </Typography>
            <Typography paragraph variant="subheading">
              2. OBJETO
            </Typography>
            <Typography paragraph>
              Las presentes Condiciones de Uso regulan el acceso, navegación y utilización del Sitio Web, 
              sin perjuicio de que se pueda modificar su presentación, configuración y contenido, así como 
              las condiciones requeridas para su acceso y/o utilización. El acceso y utilización de los 
              contenidos suponen la aceptación de los mismos.
            </Typography>
            <Typography paragraph>
              COSMOCARE se reserva el derecho a modificar los términos y condiciones aquí estipulados, 
              total o parcialmente, publicando cualquier cambio en la misma forma en que aparecen 
              estas Condiciones de Uso o a través de comunicación dirigida al usuario.
            </Typography>
            <Typography paragraph>
              A los efectos de la interpretación de las presentes Condiciones de Uso, entendemos que 
              una persona pasa a ser usuaria en el momento en que acepta este Aviso Legal o la Política 
              de Privacidad expuestas en el Sitio Web, bastando para ello que lo visite.
            </Typography>
            <Typography paragraph variant="subheading">
              3. PROHIBICIONES GENERALES
            </Typography>
            <Typography paragraph>
              Está terminante prohibido comunicar información o contenidos a través de este Sitio Web que:
            </Typography>
            <Typography paragraph className={classes.pl}>

              1. Puedan ser considerados como una vulneración en cualquier forma de los 
              derechos fundamentales al honor, a la intimidad personal y familiar o a la propia imagen 
              de terceros y, muy especialmente, de los menores de edad <br />
              2. Incluya fotografías o que recojan imágenes o datos personales de terceros 
              sin haber obtenido el oportuno consentimiento de sus titulares<br />
              3. Vulneren el secreto de las comunicaciones o supongan una infracción de derechos de 
              propiedad intelectual e industrial o de las normas reguladoras de la protección de datos 
              de carácter personal<br />
              4. Contengan cualquier material o información que sea ilegal, racista, obscena, 
              pornográfica, abusiva, difamatoria, engañosa, fraudulenta o de cualquier forma 
              contraria a la moral o al orden público<br />
              5. Contengan “spam” y/o enlaces a sitios sin relación con el espacio correspondiente<br />
              6. Incluya publicidad o comunicaciones comerciales, para la emisión de mensajes con 
              finalidad publicitaria o para la captación de datos con el mismo fin
            </Typography>
            <Typography paragraph variant="subheading">
              4. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL
            </Typography>
            <Typography paragraph>
              COSMOCARE es titular o, en su caso, cuenta con las licencias correspondientes sobre los derechos de 
              explotación de propiedad intelectual e industrial del Sitio Web, así como de todos los contenidos 
              ofrecidos en el mismo, incluyendo la propia plataforma, textos, fotografías o ilustraciones, logos, 
              marcas, grafismos, diseños, interfaces, o cualquier otra información o contenido, y los servicios 
              disponibles a través del mismo.
            </Typography>
            <Typography paragraph>
              En ningún caso se entenderá que el acceso, navegación y utilización del Sitio Web por parte 
              del usuario o la utilización de los servicios implica una renuncia, transmisión, 
              licencia o cesión total o parcial de dichos derechos. El usuario dispone de un 
              derecho de uso de los contenidos y/o servicios del Sitio Web dentro de un ámbito 
              estrictamente doméstico y únicamente con la finalidad de disfrutar de las prestaciones 
              del servicio de acuerdo con las presentes Condiciones de Uso.
            </Typography>
            <Typography paragraph>
              Las referencias a marcas o nombres comerciales registrados, u otros signos distintivos, ya sean 
              de nuestra titularidad o de terceras empresas, llevan implícita la prohibición sobre su uso 
              sin el consentimiento del prestador o de sus legítimos titulares. En ningún momento (salvo 
              manifestación expresa en contrario) el acceso, navegación o utilización del Sitio Web confiere 
              al usuario derecho alguno sobre signos distintivos en él incluidos.
            </Typography>
            <Typography paragraph>
              Quedan reservados todos los derechos de propiedad intelectual e industrial sobre los 
              contenidos y/o servicios del Sitio Web y, en particular, queda prohibido modificar, 
              copiar, reproducir, comunicar públicamente, transformar o distribuir, por cualquier 
              medio y bajo cualquier forma, la totalidad o parte de los contenidos incluidos en el 
              Sitio Web, para propósitos públicos o comerciales, si no se cuenta con la autorización 
              previa, expresa y por escrito, en su caso, del titular de los derechos correspondientes.
            </Typography>
            <Typography paragraph>
              Asimismo, queda prohibido suprimir o manipular las indicaciones de copyright u otros créditos 
              que identifiquen a los titulares de derechos de los contenidos que el usuario encuentre en el 
              Sitio Web, así como los dispositivos técnicos de protección, las huellas digitales, o 
              cualquier mecanismo de protección o información incorporada a los contenidos ofrecidos 
              en el Sitio Web.
            </Typography>
            <Typography paragraph>
              Si el usuario tuviera conocimiento de la existencia de algún contenido ilícito, ilegal, 
              contrario a las leyes o que pudiera suponer una infracción de derechos de propiedad intelectual 
              y/o industrial, deberá notificarlo inmediatamente al prestador a través de la dirección de correo 
              electrónico help@cosmocare.eu para que ésta pueda proceder a la adopción de las medidas oportunas.
            </Typography>
            <Typography paragraph>
              De igual modo, en el caso de que cualquier usuario o un tercero consideren que alguno de los contenidos del 
              Sitio Web propiedad del prestador vulnera sus derechos de propiedad intelectual y/o industrial, así como 
              cualesquiera otros derechos, deberá remitir una comunicación a help@cosmocare.eu con la 
              siguiente información:
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Datos identificativos y medio de contacto del reclamante o de su representante legal.<br/>
              - Documentación que acredite su condición de titular de los derechos supuestamente infringidos.<br/>
              - Relato detallado de los derechos supuestamente infringidos por el prestador, así como su localización exacta dentro del Sitio Web.<br/>
              - Declaración expresa por parte del reclamante de que la utilización de los contenidos se ha realizado sin el consentimiento 
              del titular de los derechos supuestamente infringidos.
            </Typography>
            <Typography paragraph variant="subheading">
              5. ENLACES
            </Typography>
            <Typography paragraph variant="subheading">
              5.1. ENLACES A OTRAS PÁGINAS WEB
            </Typography>
            <Typography paragraph>
              https://www.cosmocareportal.com 
            </Typography>
            <Typography paragraph variant="subheading">
              5.2. ENLACES AL CANAL DEL PRESTADOR EN OTRAS PLATAFORMAS Y REDES SOCIALES
            </Typography>
            <Typography paragraph variant="subheading">
              5.3. ENLACES EN OTRAS PÁGINAS WEB CON DESTINO A ESTE SITIO WEB
            </Typography>
            <Typography paragraph>
              COSMOCARE no autoriza el establecimiento de un enlace al Sitio Web desde aquellas 
              páginas que contengan materiales, información o contenidos ilícitos, ilegales, 
              degradantes, obscenos y, en general, que contravengan las leyes, la moral o el 
              orden público, o las normas sociales generalmente aceptadas.
            </Typography>
            <Typography paragraph>
              En todo caso, los usuarios podrán establecer enlaces en sus respectivas páginas web que dirijan 
              al Sitio Web, siempre y cuando cumplan con las siguientes condiciones:
            </Typography>
            <Typography paragraph className={classes.pl}>
              - El enlace no podrá reproducir el contenido del Sitio Web o partes del mismo de ninguna forma <br/>
              - No está permitido crear un browser ni un border environment sobre las secciones del 
              Sitio Web, ni de ninguna otra forma podrá modificarse el Sitio Web;<br/>
              - No está permitido realizar manifestaciones o indicaciones falsas o inexactas o 
              incorrectas sobre el Sitio Web y/o, en particular, declarar o dar a entender que el prestador 
              ha autorizado el enlace o que ha supervisado o asumido de cualquier forma los contenidos o 
              servicios ofrecidos o puestos a disposición en la página web en la que se establece dicho enlace;<br/>
              - La página web en la que se establezca el enlace al Sitio Web no contendrá informaciones o contenidos 
              ilícitos, contrarios a la moral y buenas costumbres generalmente aceptadas y al orden público, así como 
              tampoco contendrá contenidos contrarios a cualesquiera derechos de terceros, incluidos los derechos 
              de propiedad intelectual e industrial y/o el derecho al honor, a la intimidad personal o familiar 
              o a la propia imagen o de cualquier otro derecho, o contenidos contrarios a las normas reguladoras 
              de la protección de datos de carácter personal.
            </Typography>
            <Typography paragraph>
              No contamos con la facultad ni medios humanos ni técnicos para conocer, controlar ni aprobar
               toda la información, contenidos, productos o servicios facilitados por otras páginas web que 
               tengan establecidos enlaces con destino al Sitio Web por lo que no asumimos ningún tipo de 
               responsabilidad por cualquier aspecto relativo a la página web que establece ese enlace con 
               destino al Sitio Web, en concreto, a título enunciativo y no taxativo, sobre su funcionamiento, 
               acceso, datos, información, archivos, calidad y fiabilidad de sus productos y servicios, 
               sus propios enlaces y/o cualquiera de sus contenidos, en general.
            </Typography>
            <Typography paragraph variant="subheading">
              6. REGLAS DE USO DEL SITIO WEB
            </Typography>
            <Typography paragraph>
              Queda prohibido el acceso al Sitio Web por parte de menores de edad. En su caso, se presumirá 
              que el acceso se ha realizado con autorización previa y expresa de sus padres, tutores o 
              representantes legales.
            </Typography>
            <Typography paragraph>
              Además, no está permitido y, por tanto, sus consecuencias serán de la exclusiva responsabilidad del 
              usuario, el acceso o la utilización del Sitio Web con fines ilegales o no autorizados, con o sin 
              finalidad económica. En particular, y sin que el siguiente listado tenga carácter absoluto, queda 
              prohibido:
            </Typography>
            <Typography paragraph className={classes.pl}>
              1) Usar el Sitio Web en forma alguna que pueda provocar daños, interrupciones, 
              ineficiencias o defectos en su funcionamiento o en el ordenador de un tercero;<br/>
              2) Usar el Sitio Web para la transmisión, instalación o publicación de cualquier virus, código 
              malicioso u otros programas o archivos perjudiciales;<br/>
              3) Usar el Sitio Web para recoger datos de carácter personal de otros usuarios;<br/>
              4) Usar el Sitio Web de forma ilegal, en contra de la buena fe, la moral y el orden público;<br/>
              5) Quebrantar, o intentar quebrantar, las medidas de seguridad o autenticación del Sitio Web o de 
              cualquier red conectada al mismo, o las medidas de seguridad o protección inherentes a los contenidos 
              ofrecidos en el Sitio Web;<br/>
              6) Llevar a cabo alguna acción que provoque una saturación desproporcionada o innecesaria en la 
              infraestructura del Sitio Web o en los sistemas o redes del prestador, así como en los sistemas y 
              redes conectados al Sitio Web; o
            </Typography>
            <Typography paragraph>
              El incumplimiento de cualquiera de las anteriores obligaciones por el usuario podrá llevar aparejada 
              la adopción por el prestador de las medidas oportunas amparadas en Derecho y en el ejercicio de sus 
              derechos u obligaciones, pudiendo llegar a la eliminación o bloqueo de la cuenta del usuario infractor, 
              sin que medie posibilidad de indemnización alguna por los daños y perjuicios causados.
            </Typography>
            <Typography paragraph>
              El usuario que incumpla estas prohibiciones será responsable de cualquier reclamación que se produzca como 
              consecuencia de ello. Aunque no se produjera ninguna reclamación de un tercero, COSMOCARE se reserva la 
              posibilidad de impedir el acceso al Sitio Web o de la posibilidad de participar en los espacios 
              habilitados en el mismo a los usuarios que incumplan estas condiciones.
            </Typography>
            <Typography paragraph>
              COSMOCARE no controla el contenido publicado por los usuarios en el Sitio Web y no asume responsabilidad 
              alguna por estos contenidos. No obstante, nos reservamos la posibilidad de supervisar y/o moderar cualquier 
              contenido publicado por los usuarios y, en caso de que éste vulnere las presentes Condiciones de Uso o 
              la Política de Privacidad, de editarlo o eliminarlo. 
            </Typography>
            <Typography paragraph>
              Asimismo, si Ud. encuentra alguna información o contenido en el Sitio Web que pueda ser no adecuado, contrario 
              a la normativa vigente, o contrario a las condiciones dispuestas en el Sitio Web, rogamos que lo ponga en 
              conocimiento inmediato del prestador a través de los diferentes medios dispuestos para ello.
            </Typography>
            <Typography paragraph>
              Cuando el usuario utilice las direcciones de correo electrónico que ponemos a su disposición para ofrecerle 
              información general, así como información sobre la compañía, sobre entrevistas o sobre material gráfico, 
              deberá respetar las Condiciones del Sitio Web. De la misma manera, los potenciales candidatos que envíen 
              documentos o información para futuros procesos de selección o en aquellos casos en los que el usuario nos 
              contacte mediante vía telefónica. En todos los escenarios el usuario acepta que sus datos sean tratados para 
              lograr la finalidad con la que son proporcionados.
            </Typography>
            <Typography paragraph variant="subheading">
              6.1. REQUISITOS PARA PROPORCIONAR INFORMACIÓN A TRAVÉS DE NUESTROS CANALES
            </Typography>
            <Typography paragraph>
              Cuando haga uso de las direcciones de correo que al efecto se disponen en el Sitio Web, 
              es decir, correo electrónico, telefónico o presencialmente, deberá proporcionar todos 
              sus datos reales y veraces, ya que será la única forma que tendremos de poder gestionar 
              correctamente nuestra relación y/o nuestros servicios.
            </Typography>
            <Typography paragraph>
              En el caso de que el usuario envíe información de cualquier tipo a COSMOCARE a través de 
              cualquiera de los canales habilitados al efecto, el usuario declara, garantiza y acepta que 
              tiene derecho a hacerlo libremente, que dicha información no infringe ningún derecho de propiedad 
              intelectual, industrial, secreto comercial o cualesquiera otros derechos de terceros, y que 
              dicha información no tiene carácter confidencial ni es perjudicial para terceros.
            </Typography>
            <Typography paragraph>
              El usuario reconoce asumir la entera responsabilidad por cualquier comunicación que suministre 
              personalmente o a su nombre, alcanzando dicha responsabilidad sin restricción alguna la 
              exactitud, legalidad, originalidad y titularidad de la misma.
            </Typography>
            <Typography paragraph>
              Bajo ningún concepto nos responsabilizaremos de la veracidad de los datos facilitados por los 
              usuarios, por lo que cada uno de éstos será el único responsable de las posibles consecuencias, 
              errores y fallos que pudieran derivarse de la falta de calidad de los datos.
            </Typography>
            <Typography paragraph>
              Es requisito imprescindible para poder enviarnos información ser mayor de dieciocho (18) años.
            </Typography>
            <Typography paragraph variant="subheading">
              7. RESPONSABILIDAD DE COSMOCARE
            </Typography>
            <Typography paragraph>
              No podemos garantizar y, por lo tanto, no somos responsables de:
            </Typography>
            <Typography paragraph className={classes.pl}>
              1. La continuidad de los contenidos del Sitio Web<br />
              2. La ausencia de errores en dichos contenidos<br />
              3. La ausencia de virus y/o demás componentes dañinos en el Sitio Web o en el servidor que lo suministra<br />
              4. La invulnerabilidad del Sitio Web y/o la imposibilidad de vulnerar las medidas de seguridad que se adopten en el mismo<br />
              5. La falta de utilidad o rendimiento de los contenidos del Sitio Web<br />
              6. Los daños o perjuicios que cause, a sí mismo o a un tercero, cualquier persona que infringiera las condiciones, 
              normas e instrucciones que el prestador establece en el Sitio Web o a través de la vulneración de los sistemas de 
              seguridad del Sitio Web.
            </Typography>
            <Typography paragraph>
              Sin embargo, hemos adoptado todas las medidas necesarias, dentro del estado de la técnica para garantizar el 
              funcionamiento del Sitio Web y reducir al mínimo los errores del sistema, tanto desde el punto de vista técnico 
              como de los contenidos publicados en el Sitio Web.
            </Typography>
            <Typography paragraph>
              COSMOCARE no será responsable de la veracidad, integridad o actualización de las informaciones publicadas en el Sitio 
              Web provenientes de fuentes ajenas al mismo, ni asumiremos ningún tipo responsabilidad en cuanto a hipotéticos 
              perjuicios que pudieran originarse por el uso de las citadas informaciones.
            </Typography>
            <Typography paragraph variant="subheading">
              8. NORMATIVA APLICABLE
            </Typography>
            <Typography paragraph variant="subheading">
              8.1 CONFIDENCIALIDAD Y PROTECCIÓN DE DATOS
            </Typography>
            <Typography paragraph>
              Todos los datos de carácter personal facilitados durante la utilización del Sitio Web serán tratados de conformidad 
              con los dispuesto en la Política de Privacidad que todo usuario debe aceptar expresamente para poder utilizar y 
              registrarse en el sistema. Tratamos sus datos de conformidad con el Reglamento Europeo de Protección de Datos, 
              del Reglamento sobre Privacidad de las Comunicaciones y de cualquier norma que sea de aplicación en la materia. 
            </Typography>
            <Typography paragraph variant="subheading">
              8.2 COMPETENCIA Y FUERO APLICABLE
            </Typography>
            <Typography paragraph>
              Siempre que la normativa vigente al efecto prevea la posibilidad para las partes de someterse a un 
              fuero determinado, para toda cuestión litigiosa derivada o relacionada con este Sitio Web será de 
              aplicación la legislación española vigente en el momento del litigio, y nos someteremos a los Juzgados 
              y Tribunales de Madrid, así como, en su caso, a los Tribunales Arbitrales de consumo o semejantes a 
              los que nos encontremos adheridos en el momento de producirse la controversia.
            </Typography>
            <Typography paragraph>
              En el caso de que cualquier disposición del presente Aviso Legal fuese declarada nula o inaplicable, 
              en su totalidad o en parte, por cualquier Juzgado, Tribunal u órgano administrativo competente, dicha 
              nulidad o inaplicación no afectará a las restantes.
            </Typography>
            <Typography paragraph>
              El no ejercicio o ejecución por parte del prestador de cualquier derecho o disposición contenido en las 
              presentes Condiciones de Uso no constituirá una renuncia al mismo, salvo reconocimiento y acuerdo por 
              escrito por su parte.
            </Typography>
            <Typography paragraph>
              Para presentar reclamaciones en el uso de nuestros servicios, puede dirigirse por correo a la dirección electrónica 
              o física indicada en el apartado “Identificación”, comprometiéndonos a buscar en todo momento una solución
               amistosa del conflicto.
            </Typography>
            <Typography paragraph align="right">
              Última actualización: <strong>Julio de 2018</strong>
            </Typography>

          </Grid>
        </Grid>
      </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles)(Terms)
  )
);


// WEBPACK FOOTER //
// ./src/modules/shared/pages/Terms.js